import React from 'react';

// components
import { Redirect, Prompt, NavLink } from "react-router-dom";
import { Link } from 'react-router-dom';
import Header from "../../components/Header";
import TextInput from "../../components/Form/components/TextInput";
import LoadingSpinner from "../../components/LoadingSpinner";
import SelectInput from "../../components/Form/components/SelectInput";
import SuburbAutoComplete from '../../components/Form/components/AutoCompleteInput/SuburbAutoComplete';
import { COUNTRY_STATE_OPTIONS_NZ, COUNTRY_STATE_OPTIONS_AU } from "../../helpers/Constants";
import PostcodeTextInput from '../../components/Form/components/TextInput/PostcodeTextInput';
import StoreTable from './components/StoreTables';
import swal from 'sweetalert';
import RestartQueue from '../AdminTools/components/components/RestartQueue';
import NavigationBar from '../Navigation';

//services
import withAuth from "../../services/withAuth";
import AuthService from "../../services/AuthService";
import MembersApi from "../../services/portal-api/MembersApi";
import GlobalsApi from "../../services/portal-api/GlobalsApi";
import NotFound from "../NotFound";

class NewStore extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            data: {
                storeName: '',
                postcode: '',
                countryState: '',
                suburb: '',
                primaryIp: '',
                secondaryIp: ''
            },
            stores: [],
            errors: {},
            viewSlug: null,
            isFiltering: false,
            filteredStates: [],
            paginatedStates: [],
            currentPage: 1,
            itemsPerPage: 50,
            stringSuburbs: ''
        }
        this.searchSuburbs = this.searchSuburbs.bind(this);
        this.handleSuburbSelected = this.handleSuburbSelected.bind(this);

    }

    componentDidMount() {
        document.title = 'New Store - duskPortal';
        document.body.className = 'page--green';
        this._selectCountry();
        this._loadListing();
    }

    _sessionParentStore = (response) => {
        // Check for auth
        if (response.status === 401) {
            this.props.sessionExpired();
            this.setState({
                isLoading: false,
            });
            return;
        } else {
            // alert("Something went wrong");
            swal("Something went wrong", {
                icon: "warning",
                buttons: false,
                timer: 3000
            });
        }
    }

    _loadListing() {
        MembersApi.getStores((result) => {
            if (result.success) {
                const { currentPage, itemsPerPage } = this.state;
                const startIndex = (currentPage - 1) * itemsPerPage;
                const endIndex = startIndex + itemsPerPage;
                const paginatedStores = result.json.slice(startIndex, endIndex);
                this.setState({
                    stores: result.json,
                    paginatedStates: paginatedStores
                }, () => { console.log("Total stores: ", this.state.stores.length) });
            }
        })
    }

    _selectCountry() {
        MembersApi.getCountry((result, callId) => {
            const data = this.state.data;
            if (result.json.country == "NZ") {
                data["country"] = "globals_nz";
            } else if (result.json.country == "AU") {
                data["country"] = "globals_au";
            }
            if (result.success) {
                this.setState({
                    'data': data,
                });
            } else {
                if (result.status === 401) {
                    this.props.sessionExpired();
                    this.setState({
                        isLoading: false,
                    });
                    return;
                }
            }
        });

    }

    removeStore = (id) => {
        const updatedFilteredStates = this.state.filteredStates.filter(s => s.id !== id);
        const updatedPaginatedStates = this.state.paginatedStates.filter(s => s.id !== id);
        const updatedStores = this.state.stores.filter(s => s.id !== id);

        this.setState({
            stores: updatedStores,
            filteredStates: updatedFilteredStates,
            paginatedStates: updatedPaginatedStates
        });
    }

    searchStore = (store) => {
        // const filteredData = this.state.stores.filter(s => s.name.toLowerCase().includes(store.toLowerCase()));
        const filteredData = this.state.stores.filter(s => {
            const nameMatch = s.name && s.name.toLowerCase().includes(store.toLowerCase());
            const postcodeMatch = s.postcode && s.postcode.toLowerCase().includes(store.toLowerCase());
            const suburbMatch = s.suburb && s.suburb.toLowerCase().includes(store.toLowerCase());
            const stateMatch = s.state && s.state.toLowerCase().includes(store.toLowerCase());
            return nameMatch || postcodeMatch || suburbMatch || stateMatch;
        });

        this.setState({
            filteredStates: filteredData,
            isFiltering: filteredData.length == this.state.stores.length ? false : true
        }, () => {
            console.log("searching ", store.toLowerCase());
        });
    }

    handlePageChange = (pageNumber) => {
        const { itemsPerPage } = this.state;
        const startIndex = (pageNumber - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const paginatedStores = this.state.stores.slice(startIndex, endIndex);

        this.setState({
            currentPage: pageNumber,
            paginatedStates: paginatedStores
        }, () => {
            console.log("Current Page is ", this.state.currentPage);
        });
    }

    handleSuburbSelected(suburb) {
        const { data } = this.state;
        data['suburb'] = suburb.suburb;
        data['postcode'] = suburb.postcode;
        data['countryState'] = suburb.state.toLowerCase();

        this.setState({
            data: data,
        });
    }

    handleInput = (event) => {
        const errors = this.state.errors;
        const name = event.target.name;
        delete errors[name];
        let data = this.state.data;

        data[name] = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        if (event.target.value == "globals_nz" || event.target.value == "globals_au") {
            data['suburb'] = null;
            data['postcode'] = "";
            data['countryState'] = "";
        }
        this.setState({
            data: data,
            errors: errors,
            isEdited: true,
        });
    }

    handleSubmit = (event) => {

        // Prevent default behaviour
        event.preventDefault();

        // Show loading and reset state
        this.setState({
            isLoading: true,
            errors: {},
        });

        // Fetch data
        MembersApi.newStore(this.state.data, (response) => {

            // Check for errors
            if (response.success) {
                // Redirect away
                this.setState({
                    isLoading: false,
                    isEdited: false,
                    viewSlug: response.json.message,
                    storeName: '',
                    suburb: '',
                    postcode: '',
                    countryState: '',
                    primaryIp: ''
                }, () => {
                    this._loadListing();
                });
            }
            else {
                // Check for auth
                if (response.status === 401) {
                    this.props.sessionExpired();
                    this.setState({
                        isLoading: false,
                        viewSlug: null
                    });
                    return;
                }

                if (response.json.errors) {
                    this.setState({
                        isLoading: false,
                        errors: response.json.errors,
                        viewSlug: null
                    });
                }
                else if (response.json.error) {
                    this.setState({
                        isLoading: false,
                        errors: { error: response.json.error },
                        viewSlug: null
                    });
                }
                else {
                    this.setState({
                        isLoading: false,
                        viewSlug: null
                    });
                }
            }
            window.scrollTo(0, 0);
        });
    };

    searchSuburbs(_value) {
        const value = _value.toLowerCase().trim();
        const {
            suburbs,
        } = this.state;

        if (suburbs) {
            const matches = suburbs.filter(sub => sub.key.indexOf(value) !== -1)
            const distanceMatches = matches.map(m => ({ ...m, dist: m.key.length - value.length }));
            distanceMatches.sort((a, b) => a.dist - b.dist);
            return distanceMatches;
        }
        return [];
    }

    render() {

        if (sessionStorage.getItem("globals_nz") == null || sessionStorage.getItem("globals_nz") == 'undefined' || sessionStorage.getItem("globals_nz") == "") {
            GlobalsApi.getSuburbs('NZ', (result, callId) => {
                sessionStorage.setItem("globals_nz", JSON.stringify(result.json));
                // this.stringSuburbs = JSON.stringify(result.json);
                this.setState({
                    stringSuburbs: JSON.stringify(result.json)
                }, () => {
                    console.log("New Zealand: ", this.state.stringSuburbs);
                })
                // this.forceUpdate();
            });
        }

        if (sessionStorage.getItem("globals_au") == null || sessionStorage.getItem("globals_au") == 'undefined' || sessionStorage.getItem("globals_au") == "") {
            GlobalsApi.getSuburbs('AU', (result, callId) => {
                sessionStorage.setItem("globals_au", JSON.stringify(result.json));
                // this.stringSuburbs = JSON.stringify(result.json);
                // this.forceUpdate();
                this.setState({
                    stringSuburbs: JSON.stringify(result.json)
                }, () => {
                    console.log("Australia: ", this.state.stringSuburbs);
                })
            });
        } let c = '';
        if (this.state.viewSlug) {
            c = <div className="alert alert--success alert--outline text--center margin--20">{this.state.viewSlug}</div>
        }
        const errorsmsg = [];
        for (const [key, value] of Object.entries(this.state.errors)) {
            errorsmsg.push(<div key={key} className="alert alert--outline alert--error margin--40--top"><span>Sorry, unable to create store: <strong> {value} </strong> Please try again, or contact Loyalty Support if the problem persists.</span></div>);
        }
        let countryOptions = null;
        if (!this.state.data.country) {
            countryOptions = [];
        } else {
            if (this.state.data.country == "globals_nz")
                countryOptions = COUNTRY_STATE_OPTIONS_NZ;
            if (this.state.data.country == "globals_au")
                countryOptions = COUNTRY_STATE_OPTIONS_AU;
        }
        return (
            AuthService.can('stores') ? (
                <div>
                    <Header />
                        <main className="content padding--80--bot" role="main">
                            <div className="container container--wide padding--40">
                                {AuthService.getAdminType() == 1 &&
                                    <div className="info-wrap col gutter--40 margin--10--bot" style={{borderBottom: "1px solid #ccc"}}>
                                        <div className="col">
                                            <NavigationBar />
                                        </div>

                                        {AuthService.can('Create stores') &&
                                            <h2 className="text--40 text--light text--color">Create New Store</h2>
                                        }

                                        {errorsmsg}

                                        {c}

                                        {AuthService.can('Create stores') &&
                                            <form onSubmit={this.handleSubmit} className="margin--40--top validate loading--inline padding--90--bot" autoComplete="off">
                                                <span></span>
                                                <div className="col-2 gutter--40">
                                                    <div className="col">
                                                        <TextInput
                                                            name="storeName"
                                                            label="Store Name"
                                                            value={this.state.data.storeName}
                                                            error={this.state.errors.storeName}
                                                            onChange={this.handleInput}
                                                            required={true}
                                                        />
                                                    </div>
                                                    <div className="col">
                                                        <div className="col-3 gutter--15 suburb-state-postcode">
                                                            <div className="col">
                                                                <SuburbAutoComplete
                                                                    name="suburb"
                                                                    label="Suburb (Optional)"
                                                                    value={this.state.data.suburb}
                                                                    error={this.state.errors.suburb}
                                                                    onChange={this.handleInput}
                                                                    onSuburbSelected={this.handleSuburbSelected}
                                                                    country={this.state.data.country}
                                                                    extras={this.state.stringSuburbs}
                                                                />
                                                            </div>
                                                            <div className="col">
                                                                <SelectInput
                                                                    name="countryState"
                                                                    label="State"
                                                                    options={countryOptions}
                                                                    value={this.state.data.countryState}
                                                                    error={this.state.errors.countryState}
                                                                    onChange={this.handleInput}
                                                                    required={true}
                                                                />
                                                            </div>
                                                            <div className="col">
                                                                <PostcodeTextInput
                                                                    name="postcode"
                                                                    label="Postcode"
                                                                    value={this.state.data.postcode}
                                                                    error={this.state.errors.postcode}
                                                                    onChange={this.handleInput}
                                                                    required={true}
                                                                />
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div className="col-2 gutter--40">
                                                    <div className="col">
                                                        <TextInput
                                                            name="primaryIp"
                                                            label="Private IPs of stores to whitelist (Comma Separated)"
                                                            value={this.state.data.primaryIp}
                                                            error={this.state.errors.primaryIp}
                                                            onChange={this.handleInput}
                                                        />
                                                    </div>
                                                </div>

                                                <footer className="footer--form clearfix">
                                                    <div className="footer--form__left">
                                                    </div>
                                                    <div className="footer--form__right">
                                                        <button type="submit" className="btn btn--large btn--color">Create</button>
                                                    </div>
                                                </footer>
                                            </form>
                                        }
                                    </div>
                                }

                                {AuthService.can('View stores') &&
                                    <StoreTable
                                        removeStore={this.removeStore}
                                        searchStore={this.searchStore}
                                        isFiltering={this.state.isFiltering}
                                        filteredStates={this.state.filteredStates}
                                        sessionLog={this._sessionParentStore}
                                        paginatedStates={this.state.paginatedStates}
                                        handlePageChange={this.handlePageChange}
                                        currentPage={this.state.currentPage}
                                        itemsCountPerPage={this.state.itemsPerPage}
                                        totalStates={this.state.stores.length}
                                    />
                                }
                            </div>
                        </main>
                        <LoadingSpinner isVisible={this.state.isLoading} />
                </div>
            
            ): <NotFound forbidden={true} />);
    }
}


export default withAuth(NewStore);
